import type { JSX } from 'react';
import { useEffect, useRef, useState } from 'react';

import { Text } from '@change/ds-core-ui';

import { stripHtmlTags } from '@change-corgi/core/html';
import { memo } from '@change-corgi/core/react/core';
import { Translate } from '@change-corgi/core/react/i18n';

import type { PetitionContentUpdate } from 'src/app/pages/petitionDetails/shared/types';

type Props = Readonly<{
	update: PetitionContentUpdate;
}>;

export const UpdateBody = memo(function UpdateBody({ update }: Props): JSX.Element | null {
	const pRef = useRef<HTMLParagraphElement>(null);
	const [clamped, setClamped] = useState(false);

	useEffect(() => {
		const el = pRef.current;
		if (!el) return;

		const isClamped = el.scrollHeight - el.clientHeight > 0;
		setClamped(isClamped);
	}, []);

	if (!update.description) {
		return null;
	}

	return (
		<div>
			<Text
				as="div"
				ref={pRef}
				className="line-clamp-2 italic"
				expressive
				color="typography-primary"
				variant="body"
				size="medium"
			>
				{stripHtmlTags(update.description)}
			</Text>
			{clamped && (
				<Text className="text-accent-primary-500 mt-2 block text-sm underline">
					{update.type === 'dmResponse' ? (
						<Translate value="corgi.petition.details.updates.read_full_response" />
					) : (
						<Translate value="corgi.petition.details.updates.read_full_update" />
					)}
				</Text>
			)}
		</div>
	);
});
